import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-background-white',
  templateUrl: './background-white.component.html',
  styleUrls: ['./background-white.component.scss']
})
export class BackgroundWhiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
